export const isMinLength = (value: string, length: number) =>
  value.length >= length

export const hasNumber = (value: string) => /[0-9]/.test(value)

export const hasLowerCase = (value: string) => /[a-z]/.test(value)

export const hasUpperCase = (value: string) => /[A-Z]/.test(value)

// https://owasp.org/www-community/password-special-characters
export const hasSpecialChar = (value: string) =>
  /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(value)

export const isAlphanumericWithSpaces = (value: string) =>
  /^[a-zA-Z0-9\s]*$/.test(value)

export const isAlphanumericWithSpacesHyphensUnderscores = (value: string) =>
  /^[a-zA-Z0-9\s_-]*$/.test(value)

export const doesNotExceedMaxConsecutiveChars = (
  value: string,
  maxConsecutive: number = 2
) => {
  const regex = new RegExp(`(.)\\1{${maxConsecutive},}`)
  return !regex.test(value)
}
